<script>
    import ViewPhotoModal from "./ViewPhotoModal.svelte";
    import ViewVideoModal from "./ViewVideoModal.svelte";
    import LoadingIcon from "./LoadingIcon.svelte";
    import MissingData from "./MissingData.svelte";
    import {onMount} from "svelte";
    import {_} from '../lib/i18n';
    import {navigate} from "svelte-routing";
    import FreeAccessDataHiddenAlert from "./FreeAccessDataHiddenAlert.svelte";

    export let params = {};
    export let date;

    let path = '';
    $: path = (params && params.path) ? params.path : '';

    let progress = 0;
    $: progress = analyze ? analyze.postsProgress : 0;
    let mounted = false;
    $: progress && mounted && initialLoad();

    let isEnabledFreeTrial = false;
    $: isEnabledFreeTrial = params.identity.isEnabledFreeTrial();

    function gotoTariffs() {
        navigate(`${path}/dashboard/subscription`);
    }

    onMount(async () => {
        mounted = true;
    });

    const counterIncValue = 12;

    let isLoading = false;
    async function initialLoad() {
        if (progress < 100 || isLoading || items.length > 0) return;

        isLoading = true;
        try {
            await loadMore();
        } catch (err) {
            console.error(err);
        }
        isLoading = false;
    }

    export let analyze;

    let items = [];
    $: analyze && (items = (analyze.events)  ? analyze.events : []);

    let isTemporary;
    $: isTemporary = (analyze && analyze.temporary ? true : false);

    function onImageError(event) {
        event.target.src = '/spy20-lk/img/image-empty.svg';
    }

    let selectedMedia = {};

    function selectMedia(item) {
        if (isEnabledFreeTrial) {
            gotoTariffs();
            return;
        }
        selectedMedia = item;
    }

    let showPhotoModal = false;
    let showVideoModal = false;


    let showCounter = params.identity.isEnabledFreeTrial() ? 5 : 12;
    let showShowMore = false;
    $: items && (showShowMore = (items.length === showCounter));
    let isLoadingMore = false;
    async function loadMore() {
        if (items.length > 0 && params.identity.isEnabledFreeTrial()) {
            navigate(`${path}/dashboard/subscription`);
            return;
        }


        const lastScrollY = window.scrollY;
        const lastScrollX = window.scrollX;

        isLoadingMore = true;

        if (params.loadMorePosts instanceof Function) {
            try {
                const newItems = await params.loadMorePosts(analyze.id, counterIncValue, items.length, date);
                showCounter += counterIncValue;
                items = items.concat(newItems);
            } catch (err) {
                console.error(err);
                isLoadingMore = false;
            }
        }

        isLoadingMore = false;
        window.scrollTo(lastScrollX, lastScrollY);
    }

    let filteredItems = [];
    function filterItems() {
        const table = {};
        const res = items.filter(({lastname}) =>(!table[lastname] && (table[lastname] = 1)));
    }
    $: items && filterItems();
</script>


{#if !isTemporary}
    {#if (((window.shared.state.language === 'en-US' && items.length > 0) || window.shared.state.language !== 'en-US') && isEnabledFreeTrial)}
        <FreeAccessDataHiddenAlert {params} />
    {/if}
    {#if items.length > 0}
        <div class="feed-item feed-item_posts">
            <div class="feed-item__body">
                <div class="feed-item__content-wrapper">
                    {#each items as item}
                        {#if item.type === 'media' || item.type === 'new_media'}
                            {#if !item.data.videoUrl}
                                <div class="feed-item-post-content">
                                    <div class="feed-item-post-content__flag feed-item-post-content__flag_photo">
                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.75 4.58366L8.75 7.33366C8.75 7.88594 8.30228 8.33366 7.75 8.33366L2.25 8.33366C1.69772 8.33366 1.25 7.88594 1.25 7.33366L1.25 3.91699C1.25 3.36471 1.69772 2.91699 2.25 2.91699L2.625 2.91699C2.93976 2.91699 3.23615 2.7688 3.425 2.51699L3.7625 2.06699C3.95135 1.81519 4.24774 1.66699 4.5625 1.66699L5.52083 1.66699" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7.70866 1.66699V2.70866M7.70866 3.75033V2.70866M7.70866 2.70866H6.66699M7.70866 2.70866L8.75033 2.70866" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                            <ellipse cx="4.99967" cy="5.41667" rx="1.66667" ry="1.66667" stroke="#57A41B" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <div class="feed-item-post-content__img-wrapper">
                                        <img src={item.data.media} alt="image"
                                             class="feed-item-post-content__image {isEnabledFreeTrial ? 'blur-content' : ''}"
                                             on:error={onImageError}
                                             on:click={() => {
                                             selectMedia(item);
                                             showVideoModal = false;
                                             showPhotoModal = true;
                                         }}
                                        />
                                    </div>
                                </div>
                            {/if}

                            {#if item.data.videoUrl}
                                <div class="feed-item-post-content">
                                    <div class="feed-item-post-content__flag feed-item-post-content__flag_reel">
                                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_751_11794)">
                                                <path d="M6.51219 0L1.48781 0C0.666516 0.000953125 0.000953125 0.666516 0 1.48781L0 6.51219C0.000953125 7.33348 0.666516 7.99905 1.48781 8H6.51219C7.33348 7.99905 7.99905 7.33348 8 6.51219L8 1.48781C7.99905 0.666516 7.33348 0.000953125 6.51219 0ZM7.44773 1.48781V1.97017L6.04869 1.97017L5.00234 0.552266L6.5122 0.552266C7.02864 0.552844 7.44716 0.971359 7.44773 1.48781ZM4.31597 0.552266L5.36231 1.97017L3.68403 1.97017L2.63769 0.552266L4.31597 0.552266ZM0.552266 1.48781C0.552844 0.971375 0.971359 0.552859 1.48781 0.552266H1.95133L2.99767 1.97017L0.552266 1.97017V1.48781ZM6.51219 7.44773L1.48781 7.44773C0.971375 7.44716 0.552859 7.02864 0.552266 6.51219L0.552266 2.52245L7.44773 2.52245L7.44773 6.51219C7.44714 7.02862 7.02862 7.44714 6.51219 7.44773Z" fill="white" />
                                                <path d="M5.47284 4.74559L3.28823 3.48431C3.15615 3.40806 2.98727 3.45331 2.91102 3.58538C2.88679 3.62737 2.87402 3.67498 2.87402 3.72346L2.87402 6.24604C2.87402 6.39854 2.99765 6.52218 3.15015 6.52218C3.19862 6.52218 3.24624 6.50943 3.28823 6.48518L5.47284 5.22388C5.60491 5.14763 5.65016 4.97876 5.57391 4.84668C5.54966 4.80468 5.5148 4.76982 5.47284 4.74559ZM3.42629 5.76776L3.42629 4.20173L4.78251 4.98473L3.42629 5.76776Z" fill="white" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_751_11794">
                                                    <rect width="8" height="8" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div class="feed-item-post-content__img-wrapper">
                                        <img src={item.data.media} alt="reel"
                                             class="feed-item-post-content__image {isEnabledFreeTrial ? 'blur-content' : ''}"
                                             on:error={onImageError}
                                             on:click={() => {
                                             selectMedia(item);
                                             showPhotoModal = false;
                                             showVideoModal = true;
                                         }}
                                        />
                                    </div>
                                </div>
                            {/if}

                            {#if item.data.mediaType === 'video'}
                                <div class="feed-item-post-content">
                                    <div class="feed-item-post-content__flag feed-item-post-content__flag_video">
                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.33301 7.91634L3.33301 2.08301L7.91634 4.99967L3.33301 7.91634Z" stroke="#1B62A4" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                    <div class="feed-item-post-content__img-wrapper">
                                        <img src={item.data.media} alt="video"
                                             class="feed-item-post-content__image {isEnabledFreeTrial ? 'blur-content' : ''}"
                                             on:error={onImageError}
                                             on:click={() => {
                                             selectMedia(item);
                                             showPhotoModal = false;
                                             showVideoModal = true;
                                         }}
                                        />
                                    </div>
                                </div>
                            {/if}

                            {#if item.data.mediaType === 'album'}

                            {/if}



                        {/if}
                    {/each}
                </div>
            </div>
        </div>


        {#if showShowMore}
            <button class="button button_ghost feed-content__load-more-btn" on:click={loadMore} disabled={isLoadingMore}>
                <LoadingIcon show={isLoadingMore} height="16" width="16" />
                {$_('postsAndReelsResult.loadMore')}
            </button>
        {/if}
    {:else}
        <MissingData {analyze} {path} analyzeInProgress={progress != 100}  category="posts_and_reels" />
    {/if}
{/if}


{#if selectedMedia && selectedMedia.data}
<ViewPhotoModal instagramLink={selectedMedia.data.link ? selectedMedia.data.link : null} imageUrl={selectedMedia.data.media} imageCreatedAt={new Date(selectedMedia.time_epoch * 1000)} bind:show={showPhotoModal} />

<ViewVideoModal instagramLink={selectedMedia.data.link ? selectedMedia.data.link : null} videoUrl={selectedMedia.data.videoUrl} videoCreatedAt={new Date(selectedMedia.time_epoch * 1000)} bind:show={showVideoModal} />
{/if}

<style>
    .feed-item-post-content__image {
        max-width: 100%;
    }
    .blur-content {
        -webkit-filter: blur(10px);
        filter: blur(10px);
    }
</style>